import { mapState, mapMutations, mapActions } from 'vuex'
import { GENERAL_STORE } from '../store'

export default {
  data: () => ({
    isValidPromocode: false, // Нужен, чтобы не пересчитывать цену при каждом сбросе промокода
  }),
  watch: {
    promocodeValidCode(val) {
      // Отслеживаем успешный промокод
      if (val === 0) this.isValidPromocode = true
    },
    promocode(newVal) {
      this.checkPromocode()

      // При удалении промокода
      if (newVal === '' || newVal === null) {
        this.validPromocode(null) //  Выключаем валидацию

        if (this.isValidPromocode) {
          // Если уже был введён валидный промокод
          this.calculatePrice() // Пересчитываем цену
          this.isValidPromocode = false // Очищаем состояние успшного промокода
        }
      }
    },
  },
  computed: {
    ...mapState(GENERAL_STORE, ['order', 'base', 'form']),
    promocode: {
      get() {
        return this.order.promocode.value
      },
      set(value) {
        this.updatePromocode(value)
      },
    },
    promocodeValidCode() {
      return this.order.promocode.validCode
    },
    inputIcon() {
      switch (this.promocodeValidCode) {
        case null:
          return 'none'
        case -1:
          return `url('/images/redesignedForm/anim_spinner.gif')`
        case 0:
          return `url('/images/redesignedForm/green_check.svg')`
        default:
          return `url('/images/redesignedForm/wrong_cross.svg')`
      }
    },
    isPromoDisabled() {
      const validOrderStatuses = [
        0, // Запланирован
        100, // Новый (ожидает публикации)
      ]

      return (
        this.base.isEdit &&
        !validOrderStatuses.includes(+this.form.deliveryObject.info.status) &&
        !this.base.isAdmin &&
        !this.base.isRestart
      )
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updatePromocode', 'validPromocode']),
    ...mapActions(GENERAL_STORE, ['checkValidPromocode', 'calculatePrice']),
    checkPromocode() {
      // Ставим в мнимый статус "Проверяется"
      this.validPromocode(-1)

      this.checkValidPromocode()
    },
  },
  created() {
    if (this.order.promocode.value) {
      this.checkPromocode()
    }
  },
}
